import React from 'react';
import styles from './TextSection.module.css';
import {
    OptimizedMotionH2,
    OptimizedMotionP,
} from '../../../shared/ui/optimized-motion/OptimizedMotion';

const TextSection: React.FC = () => {
    return (
        <div className={styles.container}>
            <OptimizedMotionH2 className={styles.title} type="slide-down" delay={0.1}>
                Close the Feedback Loop
            </OptimizedMotionH2>
            <OptimizedMotionP className={styles.text} type="slide-down" delay={0.4}>
                Because the analytics layer sits inside SimpleeCreate, insights flow straight back
                into creation tools. Writers receive AI‑driven suggestions to tighten voice;
                designers see which color palettes perform best; managers can A/B test tone
                variations without leaving the workspace. Measurement and execution finally live in
                one continuous cycle.
            </OptimizedMotionP>
            <div className={styles.blur1}></div>
            <div className={styles.blur2}></div>
        </div>
    );
};

export default TextSection;
